// import React, { useEffect } from 'react'
// import PropTypes from 'prop-types'
// import withRouter from 'Common/withRouter'
// import { Collapse } from 'react-bootstrap'

// import { withTranslation } from 'react-i18next'

// // Import Data
// import navdata from '../LayoutMenuData'
// import { Link } from 'react-router-dom'

// const VerticalLayout = (props: any) => {
//   const path = props.router.location.pathname
//   const navData = navdata().props.children
  
//   useEffect(() => {
//     console.log(navData,"navData line 17")
//     window.scrollTo({ top: 0, behavior: 'smooth' })
//     const initMenu = () => {
//       const pathName = process.env.PUBLIC_URL + path
//       const ul: any = document.getElementById('navbar-nav')
//       const items = ul.getElementsByTagName('a')
//       let itemsArray = [...items] // converts NodeList to Array
//       removeActivation(itemsArray)
//       // let matchingMenuItem = itemsArray.find((x) => {
//       //     return x.pathname === pathName;
//       // });
//       const matchPath = (pattern: string, actualPath: string) => {
//         // Convert '/edit-package/:id' to regex like /^\/edit-package\/[^/]+$/
//         const regex = new RegExp(
//           '^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$'
//         )
//         return regex.test(actualPath)
//       }

//       const matchingMenuItem = itemsArray.find(x => {
//         const activeurl = (x.getAttribute('data-set') || '').split(',')
//         return (
//           x.pathname === pathName ||
//           activeurl.some((pattern: string) =>
//             matchPath(pattern.trim(), pathName)
//           )
//         )
//       })

//       if (matchingMenuItem) {
//         activateParentDropdown(matchingMenuItem)
//       }
//     }
//     if (props.layoutType === 'vertical') {
//       initMenu()
//     }
//   }, [path, props.layoutType])

//   function activateParentDropdown (item: any) {
//     item.classList.add('active')
//     let parentCollapseDiv = item.closest('.collapse.menu-dropdown')

//     if (parentCollapseDiv) {
//       // to set aria expand true remaining
//       parentCollapseDiv.classList.add('show')
//       parentCollapseDiv.parentElement.children[0].classList.add('active')
//       parentCollapseDiv.parentElement.children[0].setAttribute(
//         'aria-expanded',
//         'true'
//       )
//       if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
//         parentCollapseDiv.parentElement
//           .closest('.collapse')
//           .classList.add('show')
//         if (
//           parentCollapseDiv.parentElement.closest('.collapse')
//             .previousElementSibling
//         )
//           parentCollapseDiv.parentElement
//             .closest('.collapse')
//             .previousElementSibling.classList.add('active')
//       }
//       return false
//     }
//     return false
//   }

//   const removeActivation = (items: any) => {
//     let actiItems = items.filter((x: any) => x.classList.contains('active'))

//     actiItems.forEach((item: any) => {
//       if (item.classList.contains('menu-link')) {
//         if (!item.classList.contains('active')) {
//           item.setAttribute('aria-expanded', false)
//         }
//         if (item.nextElementSibling) {
//           item.nextElementSibling.classList.remove('show')
//         }
//       }
//       if (item.classList.contains('nav-link')) {
//         if (item.nextElementSibling) {
//           item.nextElementSibling.classList.remove('show')
//         }
//         item.setAttribute('aria-expanded', false)
//       }
//       item.classList.remove('active')
//     })
//   }

//   return (
//     <React.Fragment>
//       {/* menu Items */}
//       {(navData || []).map((item: any, key: number) => {
//         return (
//           <React.Fragment key={key}>
//             {/* Main Header */}
//             {item['isHeader'] ? (
//               <li className='menu-title'>
//                 <span data-key='t-menu'>{props.t(item.label)} </span>
//               </li>
//             ) : item.subItems ? (
//               <li className='nav-item'>
//                 <Link
//                   to={item.link ? item.link : '/'}
//                   onClick={item.click}
//                   className='nav-link menu-link'
//                   data-bs-toggle='collapse'
//                 >
//                   <i className={item.icon}></i>
//                   <span data-key='t-apps'>{props.t(item.label)}</span>
//                   {item.badgeName ? (
//                     <span
//                       className={'badge badge-pill bg-soft-' + item.badgeColor}
//                       data-key='t-new'
//                     >
//                       {item.badgeName}
//                     </span>
//                   ) : null}
//                 </Link>
//                 <Collapse
//                   className='menu-dropdown'
//                   // className="menu-dropdown"
//                   in={item.stateVariables}
//                 >
//                   <div id='example-collapse-text'>
//                     <ul className='nav nav-sm flex-column'>
//                       {/* subItms  */}
//                       {item.subItems &&
//                         (item.subItems || []).map(
//                           (subItem: any, key: number) => (
//                             <React.Fragment key={key}>
//                               {!subItem.isChildItem ? (
//                                 <li className='nav-item'>
//                                   <Link
//                                     to={subItem.link ? subItem.link : '/'}
//                                     className='nav-link'
//                                     data-set={subItem?.activeUrl}
//                                   >
//                                     {props.t(subItem.label)}
//                                     {subItem.badgeName ? (
//                                       <span
//                                         className={
//                                           'badge badge-pill bg-soft-' +
//                                           subItem.badgeColor
//                                         }
//                                         data-key='t-new'
//                                       >
//                                         {subItem.badgeName}
//                                       </span>
//                                     ) : null}
//                                   </Link>
//                                 </li>
//                               ) : (
//                                 <li className='nav-item'>
//                                   <Link
//                                     to={process.env.PUBLIC_URL + '/'}
//                                     onClick={subItem.click}
//                                     className='nav-link'
//                                     data-bs-toggle='collapse'
//                                   >
//                                     {props.t(subItem.label)}
//                                   </Link>
//                                   <Collapse
//                                     className='menu-dropdown'
//                                     in={subItem.stateVariables}
//                                   >
//                                     <div>
//                                       <ul className='nav nav-sm flex-column'>
//                                         {/* child subItms  */}
//                                         {subItem.subItems &&
//                                           (subItem.subItems || []).map(
//                                             (childItem: any, key: number) => (
//                                               <React.Fragment key={key}>
//                                                 {!childItem.subItems ? (
//                                                   <li className='nav-item'>
//                                                     <Link
//                                                       to={
//                                                         childItem.link
//                                                           ? childItem.link
//                                                           : '/'
//                                                       }
//                                                       className='nav-link'
//                                                     >
//                                                       {props.t(childItem.label)}
//                                                     </Link>
//                                                   </li>
//                                                 ) : (
//                                                   <li className='nav-item'>
//                                                     <Link
//                                                       to={
//                                                         process.env.PUBLIC_URL +
//                                                         '/'
//                                                       }
//                                                       onClick={childItem.click}
//                                                       className='nav-link'
//                                                       data-bs-toggle='collapse'
//                                                     >
//                                                       {props.t(childItem.label)}
//                                                     </Link>
//                                                     <Collapse
//                                                       className='menu-dropdown'
//                                                       in={
//                                                         childItem.stateVariables
//                                                       }
//                                                     >
//                                                       <div>
//                                                         <ul className='nav nav-sm flex-column'>
//                                                           {childItem.subItems.map(
//                                                             (
//                                                               subChildItem: any,
//                                                               key: number
//                                                             ) => (
//                                                               <li
//                                                                 className='nav-item'
//                                                                 key={key}
//                                                               >
//                                                                 <Link
//                                                                   to={
//                                                                     subChildItem.link
//                                                                   }
//                                                                   className='nav-link'
//                                                                 >
//                                                                   {props.t(
//                                                                     subChildItem.label
//                                                                   )}
//                                                                 </Link>
//                                                               </li>
//                                                             )
//                                                           )}
//                                                         </ul>
//                                                       </div>
//                                                     </Collapse>
//                                                   </li>
//                                                 )}
//                                               </React.Fragment>
//                                             )
//                                           )}
//                                       </ul>
//                                     </div>
//                                   </Collapse>
//                                 </li>
//                               )}
//                             </React.Fragment>
//                           )
//                         )}
//                     </ul>
//                   </div>
//                 </Collapse>
//               </li>
//             ) : (
//               <li className='nav-item'>
//                 <Link
//                   to={item.link ? item.link : '/'}
//                   className='nav-link menu-link'
//                   data-set={item?.activeUrl}
//                 >
//                   <i className={item.icon}></i>{' '}
//                   <span>{props.t(item.label)}</span>
//                   {item.badgeName ? (
//                     <span
//                       className={
//                         'badge badge-pill badge-soft-' + item.badgeColor
//                       }
//                       data-key='t-new'
//                     >
//                       {item.badgeName}
//                     </span>
//                   ) : null}
//                 </Link>
//               </li>
//             )}
//           </React.Fragment>
//         )
//       })}
//     </React.Fragment>
//   )
// }

// VerticalLayout.propTypes = {
//   location: PropTypes.object,
//   t: PropTypes.any
// }

// export default withRouter(withTranslation()(VerticalLayout))



import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import withRouter from 'Common/withRouter'
import { Collapse } from 'react-bootstrap'

import { withTranslation } from 'react-i18next'

// Import Data
import navdata from '../LayoutMenuData'
import { Link } from 'react-router-dom'
import { MecordColors } from 'Constants/Color'
import { useLocation } from 'react-router-dom'
import { clearAllTableStates } from 'utils/clearTableStates'

const matchPath = (pattern: string, actualPath: string) => {
  const regex = new RegExp(
    '^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$'
  )
  return regex.test(actualPath)
}

const isLinkActive = (subItem: any, currentPath: string) => {
  if (currentPath === subItem.link) return true;
  if (!subItem.activeUrl) return false;
  return subItem.activeUrl.some((pattern: string) => matchPath(pattern.trim(), currentPath));
};

const VerticalLayout = (props: any) => {
  const path = props.router.location.pathname
  const navData = navdata().props.children

  useEffect(() => {
    // console.log(navData, "navData line 17")
    window.scrollTo({ top: 0, behavior: 'smooth' })
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + path
      const ul: any = document.getElementById('navbar-nav')
      const items = ul.getElementsByTagName('a')
      let itemsArray = [...items] // converts NodeList to Array
      removeActivation(itemsArray)
      // let matchingMenuItem = itemsArray.find((x) => {
      //     return x.pathname === pathName;
      // });


      const matchingMenuItem = itemsArray.find(x => {
        const activeurl = (x.getAttribute('data-set') || '').split(',')
        return (
          x.pathname === pathName ||
          activeurl.some((pattern: string) =>
            matchPath(pattern.trim(), pathName)
          )
        )
      })

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    if (props.layoutType === 'vertical') {
      initMenu()
    }
  }, [path, props.layoutType])

  function activateParentDropdown(item: any) {
    item.classList.add('active')
    let parentCollapseDiv = item.closest('.collapse.menu-dropdown')

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add('show')
      parentCollapseDiv.parentElement.children[0].classList.add('active')
      parentCollapseDiv.parentElement.children[0].setAttribute(
        'aria-expanded',
        'true'
      )
      if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
        parentCollapseDiv.parentElement
          .closest('.collapse')
          .classList.add('show')
        if (
          parentCollapseDiv.parentElement.closest('.collapse')
            .previousElementSibling
        )
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.classList.add('active')
      }
      return false
    }
    return false
  }

  const removeActivation = (items: any) => {
    let actiItems = items.filter((x: any) => x.classList.contains('active'))

    actiItems.forEach((item: any) => {
      if (item.classList.contains('menu-link')) {
        if (!item.classList.contains('active')) {
          item.setAttribute('aria-expanded', false)
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show')
        }
      }
      if (item.classList.contains('nav-link')) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show')
        }
        item.setAttribute('aria-expanded', false)
      }
      item.classList.remove('active')
    })
  }

  return (
    <React.Fragment>
      {/* menu Items */}
      {(navData || []).map((item: any, key: number) => {
        return (
          <React.Fragment key={key}>
            {/* Main Header */}
            {item['isHeader'] ? (
              <li className='menu-title'>
                <span
                  data-key='t-menu'
                  style={{
                    display: 'block',
                    padding: '16px 16px 8px 16px',
                    margin: '8px 0',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    color: '#919da9',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderBottom: '1px solid rgba(171, 33, 35, 0.1)',
                    position: 'relative'
                  }}
                >
                  {props.t(item.label)}
                </span>
              </li>
            ) : item.subItems ? (
              <li className='nav-item'>
                <Link
                  to={item.link ? item.link : '/'}
                  onClick={item.click}
                  className='nav-link menu-link mx-1'
                  data-bs-toggle='collapse'
                  style={{
                    padding: '12px 16px',
                    margin: '2px 8px',
                    borderRadius: '8px',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  <i
                    className={item.icon}
                    style={{
                      fontSize: '18px',
                      marginRight: '0px',
                      transition: 'transform 0.3s ease',
                      display: 'inline-flex',
                      alignItems: 'center'
                    }}
                  ></i>
                  <span
                    data-key='t-apps'
                    style={{
                      fontWeight: '500',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    {props.t(item.label)}
                  </span>
                  {item.badgeName ? (
                    <span
                      className={'badge badge-pill bg-soft-' + item.badgeColor}
                      data-key='t-new'
                      style={{
                        marginLeft: 'auto',
                        fontSize: '0.7rem',
                        padding: '2px 6px',
                        borderRadius: '10px'
                      }}
                    >
                      {item.badgeName}
                    </span>
                  ) : null}
                </Link>
                <Collapse
                  className='menu-dropdown'
                  // className="menu-dropdown"
                  in={item.stateVariables}
                >
                  <div id='example-collapse-text' style={{ maxWidth: 230 }}>
                    <ul className='nav nav-sm flex-column ps-0' style={{ listStyle: 'none' }}>
                      {/* subItms  */}
                      {item.subItems &&
                        (item.subItems || []).map(
                          (subItem: any, key: number) => (
                            <React.Fragment key={key}>
                              {!subItem.isChildItem ? (
                                <li className="nav-item ps-0" style={{ listStyle: 'none' }}>
                                  <Link
                                    to={subItem.link ? subItem.link : '/'}
                                    className="nav-link"
                                    data-set={subItem?.activeUrl}
                                    onClick={() => {
                                      // Clear all table states when clicking sidebar navigation links
                                      if (
                                        subItem.link &&
                                        subItem.link !== "/#"
                                      ) {
                                        clearAllTableStates();
                                      }
                                    }}
                                    style={{
                                      // Enhanced active state styling
                                      ...(isLinkActive(subItem, window.location.pathname) && {
                                        borderLeft: `4px solid ${MecordColors?.ThemeBGColor}`,
                                        borderRadius: "0px 17px 17px 0",
                                        backgroundColor: MecordColors?.ActiveBackground,
                                        color: MecordColors?.ActiveText,
                                        fontWeight: '600',
                                        boxShadow: '0 2px 8px rgba(171, 33, 35, 0.15)',
                                        transform: 'translateX(4px)'
                                      }),
                                      padding: '10px 16px',
                                      paddingLeft: '20px',
                                      margin: '2px 8px',
                                      borderRadius: '6px',
                                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                      position: 'relative',
                                      overflow: 'hidden'
                                    }}
                                  >
                                    <span
                                      style={{
                                        position: 'relative',
                                        zIndex: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%'
                                      }}
                                    >
                                      {/* Sub-item icon - use menu data icon if available */}
                                      {subItem.icon && (
                                        <i
                                          className={subItem.icon}
                                          style={{
                                            fontSize: '16px',
                                            marginRight: '0px',
                                            transition: 'all 0.3s ease',
                                            color: window.location.pathname === (subItem.link || "/")
                                              ? MecordColors?.ThemeBGColor
                                              : 'rgba(171, 33, 35, 0.6)',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            flexShrink: 0
                                          }}
                                        ></i>
                                      )}
                                      {props.t(subItem.label)}
                                    </span>

                                    {subItem.badgeName ? (
                                      <span
                                        className={'badge badge-pill bg-soft-' + subItem.badgeColor}
                                        data-key="t-new"
                                        style={{
                                          marginLeft: 'auto',
                                          fontSize: '0.7rem',
                                          padding: '2px 6px',
                                          borderRadius: '10px',
                                          backgroundColor: MecordColors?.ActiveBackground,
                                          color: MecordColors?.ActiveText
                                        }}
                                      >
                                        {subItem.badgeName}
                                      </span>
                                    ) : null}
                                  </Link>
                                </li>

                              ) : (
                                <li className='nav-item'>
                                  <Link
                                    to={process.env.PUBLIC_URL + '/'}
                                    onClick={subItem.click}
                                    className='nav-link'
                                    data-bs-toggle='collapse'
                                  >
                                    {props.t(subItem.label)}
                                  </Link>
                                  <Collapse
                                    className='menu-dropdown'
                                    in={subItem.stateVariables}
                                  >
                                    <div>
                                      <ul className='nav nav-sm flex-column' style={{ listStyle: 'none' }}>
                                        {/* child subItms  */}
                                        {subItem.subItems &&
                                          (subItem.subItems || []).map(
                                            (childItem: any, key: number) => (
                                              <React.Fragment key={key}>
                                                {!childItem.subItems ? (
                                                  <li className='nav-item'>
                                                    <Link
                                                      to={
                                                        childItem.link
                                                          ? childItem.link
                                                          : '/'
                                                      }
                                                      className='nav-link'
                                                      onClick={() => {
                                                        // Clear all table states when clicking sidebar navigation links
                                                        if (
                                                          childItem.link &&
                                                          childItem.link !==
                                                            "/#"
                                                        ) {
                                                          clearAllTableStates();
                                                        }
                                                      }}
                                                    >
                                                      {props.t(childItem.label)}
                                                    </Link>
                                                  </li>
                                                ) : (
                                                  <li className='nav-item'>
                                                    <Link
                                                      to={
                                                        process.env.PUBLIC_URL +
                                                        '/'
                                                      }
                                                      onClick={childItem.click}
                                                      className='nav-link'
                                                      data-bs-toggle='collapse'
                                                    >
                                                      {props.t(childItem.label)}
                                                    </Link>
                                                    <Collapse
                                                      className='menu-dropdown'
                                                      in={
                                                        childItem.stateVariables
                                                      }
                                                    >
                                                      <div>
                                                        <ul className='nav nav-sm flex-column' style={{ listStyle: 'none' }}>
                                                          {childItem.subItems.map(
                                                            (
                                                              subChildItem: any,
                                                              key: number
                                                            ) => (
                                                              <li
                                                                className='nav-item'
                                                                key={key}
                                                              >
                                                                <Link
                                                                  to={
                                                                    subChildItem.link
                                                                  }
                                                                  className='nav-link'
                                                                  onClick={() => {
                                                                    // Clear all table states when clicking sidebar navigation links
                                                                    if (
                                                                      subChildItem.link &&
                                                                      subChildItem.link !==
                                                                        "/#"
                                                                    ) {
                                                                      clearAllTableStates();
                                                                    }
                                                                  }}
                                                                >
                                                                  {props.t(
                                                                    subChildItem.label
                                                                  )}
                                                                </Link>
                                                              </li>
                                                            )
                                                          )}
                                                        </ul>
                                                      </div>
                                                    </Collapse>
                                                  </li>
                                                )}
                                              </React.Fragment>
                                            )
                                          )}
                                      </ul>
                                    </div>
                                  </Collapse>
                                </li>
                              )}
                            </React.Fragment>
                          )
                        )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            ) : (
              <li className='nav-item'>
                <Link
                  to={item.link ? item.link : '/'}
                  className='nav-link menu-link'
                  data-set={item?.activeUrl}
                   onClick={() => {
                    // Clear all table states when clicking sidebar navigation links
                    if (item.link && item.link !== "/#") {
                      clearAllTableStates();
                    }
                  }}
                  style={{
                    padding: '12px 16px',
                    margin: '2px 8px',
                    borderRadius: '8px',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <i
                    className={item.icon}
                    style={{
                      fontSize: '18px',
                      marginRight: '12px',
                      transition: 'transform 0.3s ease',
                      display: 'inline-flex',
                      alignItems: 'center'
                    }}
                  ></i>
                  <span
                    style={{
                      fontWeight: '500',
                      transition: 'color 0.3s ease',
                      flex: 1
                    }}
                  >
                    {props.t(item.label)}
                  </span>
                  {item.badgeName ? (
                    <span
                      className={
                        'badge badge-pill badge-soft-' + item.badgeColor
                      }
                      data-key='t-new'
                      style={{
                        fontSize: '0.7rem',
                        padding: '2px 6px',
                        borderRadius: '10px',
                        backgroundColor: MecordColors?.ActiveBackground,
                        color: MecordColors?.ActiveText
                      }}
                    >
                      {item.badgeName}
                    </span>
                  ) : null}
                </Link>
              </li>
            )}
          </React.Fragment>
        )
      })}
    </React.Fragment>
  )
}

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any
}

export default withRouter(withTranslation()(VerticalLayout))
